/**
 * External marketing / help URLs with UTM tracking.
 *
 * Keep all outbound links to decisivelabsllc.com here so (a) there's one
 * place to change them if the URLs ever move, and (b) every click gets a
 * consistent utm_source=app + source-specific utm_medium so we can see in
 * Google Analytics / Netlify Analytics which placement is actually driving
 * traffic back to the marketing site.
 */

const BASE_WEBSITE = 'https://decisivelabsllc.com/fueltron';
const BASE_FEATURE_GUIDE = 'https://decisivelabsllc.com/blog/fueltron-feature-guide';
const BASE_FOUNDER_STORY = 'https://decisivelabsllc.com/blog/fueltron-journey';

export type LinkSource = 'header-help' | 'settings-feature-guide' | 'settings-website' | 'landing-learn-more' | 'landing-story';

function withUtm(url: string, source: LinkSource): string {
  const params = new URLSearchParams({
    utm_source: 'app',
    utm_medium: source,
    utm_campaign: 'in_app_links',
  });
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${params.toString()}`;
}

export const externalLinks = {
  website: (source: LinkSource) => withUtm(BASE_WEBSITE, source),
  featureGuide: (source: LinkSource) => withUtm(BASE_FEATURE_GUIDE, source),
  founderStory: (source: LinkSource) => withUtm(BASE_FOUNDER_STORY, source),
};

/**
 * Opens an external URL in a new tab safely.
 * Uses noopener+noreferrer to prevent the opened page from accessing
 * window.opener (reverse tabnapping prevention).
 */
export function openExternalLink(url: string): void {
  window.open(url, '_blank', 'noopener,noreferrer');
}
